import { library } from '@fortawesome/fontawesome-svg-core'

import { faArrowRight } from '@fortawesome/pro-light-svg-icons/faArrowRight'
import { faCopy as fasCopy } from '@fortawesome/pro-solid-svg-icons/faCopy'
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown'
import { faExternalLink } from '@fortawesome/pro-solid-svg-icons/faExternalLink'
import { faLink } from '@fortawesome/pro-solid-svg-icons/faLink'
import { faSearch } from '@fortawesome/pro-solid-svg-icons/faSearch'
import { faSearch as farSearch } from '@fortawesome/pro-regular-svg-icons/faSearch'
import { faSearch as falSearch } from '@fortawesome/pro-light-svg-icons/faSearch'

import { faCopy } from '@fortawesome/pro-regular-svg-icons/faCopy'
import { faCaretCircleDown } from '@fortawesome/pro-regular-svg-icons/faCaretCircleDown'
import { faCube } from '@fortawesome/pro-regular-svg-icons/faCube'
import { faExclamation } from '@fortawesome/pro-regular-svg-icons/faExclamation'
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons/faExclamationTriangle'
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle'
import { faInfoCircle as faInfoCircleLight } from '@fortawesome/pro-light-svg-icons/faInfoCircle'
import { faInfoCircle as faInfoCircleRegular } from '@fortawesome/pro-regular-svg-icons/faInfoCircle'
import { faCheckCircle as faCheckCircleLight } from '@fortawesome/pro-light-svg-icons/faCheckCircle'
import { faTimesCircle as faTimesCircleLight } from '@fortawesome/pro-light-svg-icons/faTimesCircle'
import { faSirenOn } from '@fortawesome/pro-regular-svg-icons/faSirenOn'
import { faStar } from '@fortawesome/pro-regular-svg-icons/faStar'
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes'
import { faUserShield } from '@fortawesome/pro-regular-svg-icons/faUserShield'
import { faExternalLink as falExternalLink } from '@fortawesome/pro-light-svg-icons/faExternalLink'
import { faPlusCircle } from '@fortawesome/pro-regular-svg-icons/faPlusCircle'
import { faMinusCircle } from '@fortawesome/pro-regular-svg-icons/faMinusCircle'
import { faIcons } from '@fortawesome/pro-light-svg-icons/faIcons'
import { faFilter } from '@fortawesome/pro-regular-svg-icons/faFilter'

const Icons = {
  init: () =>
    library.add(
      faArrowRight,
      faCopy,
      fasCopy,
      faCaretCircleDown,
      faChevronDown,
      faCube,
      faExclamation,
      faExclamationTriangle,
      faExternalLink,
      faInfoCircle,
      faLink,
      faSearch,
      farSearch,
      falSearch,
      faSirenOn,
      faStar,
      faTimes,
      faUserShield,
      falExternalLink,
      faPlusCircle,
      faMinusCircle,
      faIcons,
      faFilter,
      faInfoCircleLight,
      faInfoCircleRegular,
      faCheckCircleLight,
      faTimesCircleLight
    ),
}

export default Icons
